import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input } from 'reactstrap'
import Select from "react-select";
import TableContainer from '../../Components/Common/TableContainerReactTable';
import Flatpickr from "react-flatpickr";
import ModalCrearRecepcionVehiculo from '../../Components/modals/ModalCrearRecepcionVehiculo';
import citasHooks from '../../Components/Hooks/CitasHooks';
import useCreateRecepcionVehiculo from '../../Components/Hooks/useCreateRecepcionVehiculo';
import ModalModificarVehiculo from '../../Components/modals/ModalModificarVehiculo';
import { set } from 'lodash';

const Citas = () => {
  const navigate = useNavigate();
  const [citaPrecargada, setCitaPrecargada] = useState({})
  const [patenteSeleccionada, setPatenteSeleccionada] = useState(null);
  const [estadoCitas, setEstadoCitas] = useState({ value: 'no_recepcionadas', label: "Sin recepcionar" })
  const d = new Date();
  let hoy = d.toISOString().substring(0, 10)
  const [fechaInicio, setFechaInicio] = useState(hoy)
  const [fechaTermino, setFechaTermino] = useState(hoy)

  const formatDate = (date) => {
    if (!date) return '';
    const _date = new Date(date)
    const year = _date.getFullYear();
    const month = String(_date.getMonth() + 1).padStart(2, '0');
    const day = String(_date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const citasFiltradas = () => {
    if (!Array.isArray(citas))
      return []
    switch (estadoCitas.value) {
      case 'todas':
        return citas
      case 'no_recepcionadas':
        return citas.filter(cita => cita.nrorecep == null)
      case 'recepcionadas':
        let res = citas.filter(cita => cita.nrorecep != null)
        return res
      default:
        return []
    }
  }

  const handleVerCita = (rowData) => {
    if (rowData.nrorecep != null) {
      // Cita ya recepcionada: navegar para ver la recepción existente
      navigate('/servicios/historial-recepciones', {
        state: {
          verRecepcion: rowData.nrorecep
        }
      });
    } else {
      // Cita no recepcionada: navegar para crear recepción precargada
      navigate('/servicios/historial-recepciones', {
        state: {
          citaPrecargada: {
            patente: typeof rowData.PATENT === 'string' ? rowData.PATENT : '',
            rut_contacto: typeof rowData.CLIENT === 'string' ? rowData.CLIENT.trim() : '',
            contacto: typeof rowData.OBSER2 === 'string' ? rowData.OBSER2.trim() : '',
            email: typeof rowData.MAICON === 'string' ? rowData.MAICON.trim() : '',
            telefono: typeof rowData.FONCON === 'string' ? rowData.FONCON.trim() : '',
            cita: rowData.NUMERO,
            tipo_trabajo_ot: rowData.TTRABA,
            solicitud_cliente: typeof rowData.OBSERV === 'string' ? rowData.OBSERV : ''
          }
        }
      });
    }
  }
  const handleEstadoCitasChange = (opcion) => {
    setEstadoCitas(opcion)
  }
  const handleFechaInicioChange = (date) => {
    setFechaInicio(formatDate(date[0]));
  };

  const handleFechaTerminoChange = (date) => {
    setFechaTermino(formatDate(date[0]));
  };

  const { citas, loading, error } = citasHooks(fechaInicio, fechaTermino);
  const { createRecepcion, loading: createLoading, error: createError } = useCreateRecepcionVehiculo();

  useEffect(() => {
    document.title = "Citas del Sistema | Siga ERP";
  }, []);


  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "NUMERO",
        enableColumnFilter: false,
      },
      {
        header: "Fecha",
        accessorKey: "fecha",
        enableColumnFilter: false,
      },
      {
        header: "Hora",
        accessorKey: "hora",
        enableColumnFilter: false,
      },
      {
        header: "Patente",
        accessorKey: "PATENT",
        enableColumnFilter: false,
      },
      {
        header: "Cliente",
        accessorKey: "CLIENT",
        enableColumnFilter: false,
      },
      {
        header: "Contacto",
        accessorKey: "OBSER2",
        enableColumnFilter: false,
      },
      {
        header: "Fono contacto",
        accessorKey: "FONCON",
        enableColumnFilter: false,
      },
      {
        header: "Tipo trabajo",
        accessorKey: "tipotrabajo",
        enableColumnFilter: false,
      },
      {
        header: "N° Recepción",
        accessorKey: "nrorecep",
        enableColumnFilter: false,
      }
    ],
    []
  );

  const handleCellClick = (cellInfo) => {
    console.log('Celda clickeada:', cellInfo);
    console.log('Columna:', cellInfo.columnId);
    console.log('Valor:', cellInfo.value);
    console.log('Datos completos de la fila:', cellInfo.rowData);
    if (cellInfo.value == null) return;

    switch (cellInfo.columnId) {
      case 'NUMERO':
        handleVerCita(cellInfo.rowData);
        break;
      case 'PATENT':
        setPatenteSeleccionada(cellInfo.value);
        handleModalVehiculo();
        break;
      default:
        break;
    }

    // if (cellInfo.rowData.nrorecep == null) {
    //   setCitaPrecargada({
    //     patente: typeof cellInfo.rowData.PATENT == 'string' ? cellInfo.rowData.PATENT : '',
    //     rut_contacto: typeof cellInfo.rowData.CLIENT == 'string' ? cellInfo.rowData.CLIENT.trim() : '',
    //     contacto: typeof cellInfo.rowData.OBSER2 == 'string' ? cellInfo.rowData.OBSER2.trim() : '',
    //     email: typeof cellInfo.rowData.MAICON == 'string' ? cellInfo.rowData.MAICON.trim() : '',
    //     telefono: typeof cellInfo.rowData.FONCON == 'string' ? cellInfo.rowData.FONCON.trim() : '',
    //     cita: cellInfo.rowData.NUMERO,
    //     tipo_trabajo_ot: cellInfo.rowData.TTRABA,
    //     solicitud_cliente: cellInfo.rowData.OBSERV
    //   })
    //   handleCrear()
    // }
  };

  const [modalCrear, setModalCrear] = useState(false);
  const [modalModificarVehiculo, setModalModificarVehiculo] = useState(false);
  const toggleModalCrear = () => {
    setModalCrear(!modalCrear);
  };

  const toggleModalVehiculo = () => {
    setModalModificarVehiculo(!modalModificarVehiculo);
  };


  const handleGuardarVehiculo = () => {
    // Lógica para guardar el vehículo modificado
    setModalModificarVehiculo(false);
  };

  const handleCrear = () => {
    setModalCrear(true);
  }

  const handleModalVehiculo = () => {
    setModalModificarVehiculo(true);
  };



  const handleGuardarRecepcion = async (datosRecepcion) => {
    const result = await createRecepcion(datosRecepcion);
    if (result.success) {
      setModalCrear(false);
    }
    // Error is handled in the hook
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Citas</h5>
                  <div className="d-flex align-items-center">
                    <Label className="form-label mb-0 me-2">Estado</Label>
                    <div className="mt-0  me-2">
                      <Select
                        id="Estado"
                        value={estadoCitas}
                        onChange={handleEstadoCitasChange}
                        options={[
                          { value: 'todas', label: 'Todas' },
                          { value: 'no_recepcionadas', label: 'Sin recepcionar' },
                          { value: 'recepcionadas', label: 'Recepcionadas' }]}
                        onFocus={(e) => {
                          e.target.readOnly = true;
                        }}
                      />
                    </div>
                    <Label className="form-label mb-0 me-2">Desde</Label>
                    <div className="mt-0  me-2">
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d"
                        }}
                        value={fechaInicio}
                        onChange={handleFechaInicioChange}
                      />
                    </div>
                    <Label className="form-label mb-0 me-2">Hasta</Label>
                    <div className="mt-0">
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d"
                        }}
                        value={fechaTermino}
                        onChange={handleFechaTerminoChange}
                      />
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  {loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                    columns={(columns || [])}
                    data={citasFiltradas()}
                    customPageSize={15}
                    isGlobalFilter={true}
                    onCellClick={handleCellClick}
                    SearchPlaceholder='Buscar...'
                  />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ModalCrearRecepcionVehiculo
        isOpen={modalCrear}
        toggle={toggleModalCrear}
        onSave={handleGuardarRecepcion}
        citaPrecargada={citaPrecargada}
      />
      <ModalModificarVehiculo
        isOpen={modalModificarVehiculo}
        toggle={toggleModalVehiculo}
        onSave={handleGuardarVehiculo}
        patente={patenteSeleccionada} />
    </React.Fragment>
  )
}

export default Citas;